module.exports = __webpack_public_path__ + "static/media/18ECA49.f8455fc6.jpg";